import { render, staticRenderFns } from "./ActionsTable.vue?vue&type=template&id=6ff0d50e"
import script from "./ActionsTable.vue?vue&type=script&lang=js"
export * from "./ActionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports